import React, { useState, useEffect, useContext } from "react";
import { navigate } from "gatsby";
import { BreadcrumbsContext } from "../../context/BreadcrumbsContext";
import { AuthContext } from "../../context/AuthContext";
import { LoadingContext } from "../../context/LoadingContext";
import useAxios from "../../hooks/useAxios";
import axios from "axios";
import { useIsMobile } from "../../hooks/useIsMobile";
import { TRENDYOL_API, HEPSIBURADA_API, AMAZON_API, ELEKTRONIK_API, N11_API, PAZARAMA_API, IDEFIX_API } from "../../consts/Endpoints";
import { PATH_ADMIN, PATH_T_CONTROL_PANEL, PATH_H_CONTROL_PANEL, PATH_A_CONTROL_PANEL, PATH_REDIRECT, PATH_T_CARD_DETAIL, PATH_H_CARD_DETAIL, PATH_A_CARD_DETAIL, PATH_E_CARD_DETAIL, PATH_E_CONTROL_PANEL, PATH_N_CARD_DETAIL, PATH_N_CONTROL_PANEL, PATH_PZ_CARD_DETAIL, PATH_PZ_CONTROL_PANEL, PATH_IX_CARD_DETAIL, PATH_IX_CONTROL_PANEL } from "../../consts/RouterPaths";
import { TELEGRAM_KANAL, WHATSAPP_KANAL, INSTAGRAM_HESABI } from "../../consts/Kanallar";
import KaydirmaSeridi from "../KaydirmaSeridi";
import GenericCardV2, { kartEtiketleri } from "../GenericUrunCardV2";
import { showAlert } from "../../utils/site";
import { RESPONSE_TYPE } from "../../consts/ResponseType";
import { SSR_DETAY_ONBELLEK_BASLIKLARI, sunucuBasliklari, istemciGecisiMi, istemciGecisiCevabi } from "../../utils/ssrOnbellek";
import { Seo } from "../Seo";
import GenericBreadcrumbs from "../Layout/Breadcrumb/GenericBreadcrumb";
import AdCardDetail from "../Ads/AdCardDetail";
import TakipEt from "../TakipEt";
import TelegramIcon from "@mui/icons-material/Telegram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import TakipDugmeleri from "../uye/TakipDugmeleri";
import DigerMagazalar from "./DigerMagazalar";
import FiyatGecmisi, { tl } from "../FiyatGecmisi";
import "./urunDetay.css";

/**
 * İndirim detay sayfası (Trendyol / Hepsiburada / Amazon ortak). Sayfa dosyaları (pages/details/*CardDetail.js) sadece
 * getServerData + Head + bu bileşeni verir; eskiden üç sayfa birebir kopyaydı.
 *
 * SSR: Telegram / WhatsApp linkinden gelen kullanıcı ürünü ilk HTML'de görür ve link önizlemesi ürünün adı + görseliyle
 * çıkar. Netlify CDN önbelleği kısa (utils/ssrOnbellek). Amazon: fiyat gösterilmez (ortaklık koşulu, `fiyatGizle`).
 */
export const SITELER = {
  trendyol: {
    ad: "Trendyol", api: TRENDYOL_API, renk: "#f27a1a", liste: "/tdetails", panel: PATH_T_CONTROL_PANEL, detay: PATH_T_CARD_DETAIL,
    uyelik: { TY_PLUS: "Bu fiyat Trendyol Plus üyelerine özel" },
  },
  hepsiburada: {
    ad: "Hepsiburada", api: HEPSIBURADA_API, renk: "#ff6000", liste: "/hdetails", panel: PATH_H_CONTROL_PANEL, detay: PATH_H_CARD_DETAIL,
    uyelik: { PREMIUM: "Bu fiyat Hepsiburada Premium üyelerine özel" },
  },
  amazon: {
    ad: "Amazon", api: AMAZON_API, renk: "#f59e0b", yaziRengi: "#111827", liste: "/adetails", panel: PATH_A_CONTROL_PANEL, detay: PATH_A_CARD_DETAIL,
    fiyatGizle: true, uyelik: {},
    // Amazon Ortaklık Programı sözleşmesi sitede bu beyanı istiyor
    ortaklikBeyani: "Bir Amazon Ortağı olarak uygun alışverişlerden kazanç sağlıyoruz.",
  },
  // MediaMarkt + Vatan tek servis; ürünün gerçek mağazası adı / rengi siteBilgisi(site, urun) ile
  elektronik: {
    ad: "MediaMarkt / Vatan", api: ELEKTRONIK_API, renk: "#0f766e", liste: "/edetails", panel: PATH_E_CONTROL_PANEL, detay: PATH_E_CARD_DETAIL,
    uyelik: {},
    ortaklik: false, // MediaMarkt / Vatan ile ortaklık (affiliate) yok
  },
  n11: {
    ad: "n11", api: N11_API, renk: "#5b2c83", liste: "/ndetails", panel: PATH_N_CONTROL_PANEL, detay: PATH_N_CARD_DETAIL,
    uyelik: { SEPET: "Bu fiyat sepette ek indirimle" },
    ek: "de",        // "n11'de gör" (diğerleri 'da)
    ortaklik: false, // n11 ile ortaklık (affiliate) yok: #Ortaklık etiketleri gösterilmez
  },
  pazarama: {
    ad: "Pazarama", api: PAZARAMA_API, renk: "#2541e6", liste: "/pzdetails", panel: PATH_PZ_CONTROL_PANEL, detay: PATH_PZ_CARD_DETAIL,
    uyelik: { SEPET: "Bu fiyat sepette indirimle" },
    ortaklik: false, // Pazarama ile ortaklık (affiliate) yok
  },
  idefix: {
    ad: "İdefix", api: IDEFIX_API, renk: "#006bdc", liste: "/ixdetails", panel: PATH_IX_CONTROL_PANEL, detay: PATH_IX_CARD_DETAIL,
    uyelik: {},
    ek: "te",        // "İdefix'te gör"
    ortaklik: false, // İdefix ile ortaklık (affiliate) yok
  },
};

/** Mağaza adına gelen bulunma eki: "Trendyol'da", "n11'de". */
export const ekli = (s, ek) => s.ad + "'" + (s.ek || "da") + (ek || "");

/** Elektronik mağazaları (urun.magaza / urun_indirim.magaza; id öneki MM- / VT-). */
export const ELEKTRONIK_MAGAZALARI = {
  MEDIAMARKT: { ad: "MediaMarkt", renk: "#df0000", liste: "/mmdetails", ek: "ta" }, // "MediaMarkt'ta"
  VATAN: { ad: "Vatan Bilgisayar", renk: "#1d4ed8", liste: "/vdetails" },
};

export const elektronikMagazasi = (u) => {
  if (!u) return null;
  const kod = u.magaza || (String(u.id || "").startsWith("MM-") ? "MEDIAMARKT" : String(u.id || "").startsWith("VT-") ? "VATAN" : null);
  return ELEKTRONIK_MAGAZALARI[kod] || null;
};

/** Site ayarları; elektronikte ad ve renk ürünün gerçek mağazasından (MediaMarkt / Vatan). */
export function siteBilgisi(site, u) {
  const s = SITELER[site];
  const m = site === "elektronik" ? elektronikMagazasi(u) : null;
  return m ? { ...s, ...m } : s;
}

/** Sayfa dosyalarının getServerData'sı. Site içi geçişte Azure'a gitmez (veri tarayıcıdan, utils/ssrOnbellek). */
export async function detaySunucuVerisi(site, query, url) {
  if (istemciGecisiMi(url)) {
    return istemciGecisiCevabi();
  }
  const oid = query && query.oid;
  if (!oid) {
    return { props: {} };
  }
  try {
    const response = await fetch(SITELER[site].api + "api/urundetaygetir?oid=" + encodeURIComponent(oid), {
      method: "GET",
      headers: sunucuBasliklari(),
    });
    if (!response.ok) {
      throw new Error("HTTP " + response.status);
    }
    return { headers: SSR_DETAY_ONBELLEK_BASLIKLARI, props: { veri: await response.json() } };
  } catch (error) {
    console.log(error);
    return { props: {} }; // sayfa istemcide kendisi çeker
  }
}

/** Sayfa dosyalarının Head'i: link önizlemesi (WhatsApp / Telegram / X) ürün adı + görsel (Amazon'da fiyatsız). */
export function DetayBasligi({ site, serverData }) {
  const u = serverData && serverData.veri && serverData.veri.urun;
  const s = siteBilgisi(site, u);
  if (!u) {
    return <Seo title={s.ad + " - İndirimli Ürün Detayı"} />;
  }
  if (s.fiyatGizle) {
    return <Seo title={`${s.ad} fırsatı: ${u.name} | İndirim Uzmanı`}
      description={`${ekli(s, "ki")} güncel fiyatı ve fiyat geçmişi analizini İndirim Uzmanı'nda gör.`} image={u.imageUrl} />;
  }
  return <Seo title={`%${u.indirimOraniYuzde} indirim: ${u.name} - ${u.yeniFiyat} TL | İndirim Uzmanı`}
    description={`${ekli(s)} ${u.eskiFiyat} TL yerine ${u.yeniFiyat} TL. Fiyat geçmişi ve indirim analizi İndirim Uzmanı'nda.`}
    image={u.imageUrl} />;
}

/** "12 dk önce" — sunucu ile tarayıcının saati farklı olacağı için sadece tarayıcıda hesaplanır. */
function neKadarOnce(tarih) {
  const dk = Math.floor((Date.now() - new Date(tarih).getTime()) / 60000);
  if (isNaN(dk)) return null;
  if (dk < 1) return "az önce";
  if (dk < 60) return dk + " dk önce";
  if (dk < 60 * 24) return Math.floor(dk / 60) + " saat önce";
  return Math.floor(dk / (60 * 24)) + " gün önce";
}

const durumYazisi = (u) => ({ DEVAM: "İndirim devam ediyor", SONA_ERDI: "İndirim sona erdi", SATISTA_DEGIL: "Satışta değil" }[u.indirimDurumu] || "Kontrol ediliyor");
const durumRengi = (u) => ({ DEVAM: "#15803d", SONA_ERDI: "#b45309", SATISTA_DEGIL: "#6b7280" }[u.indirimDurumu] || "#374151");

const tarihSaat = (t) => t ? new Date(t).toLocaleString("tr-TR", {
  day: "numeric", month: "long", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Istanbul",
}) : null;

/** İndirimin şu anki durumu (backend IndirimDurumuService + vitrin kontrolü). BILINMIYOR / alan yoksa gösterilmez. */
function DurumBandi({ u, fiyatGizle }) {
  const [once, setOnce] = useState(null);
  useEffect(() => {
    setOnce(u && u.durumKontrolTarihi ? neKadarOnce(u.durumKontrolTarihi) : null);
  }, [u]);
  if (!u || !u.indirimDurumu || u.indirimDurumu === "BILINMIYOR") {
    return null;
  }
  const kontrol = once ? <span style={{ color: "#68727e", fontSize: 12 }}> · {once} kontrol edildi</span> : null;
  if (u.indirimDurumu === "DEVAM") {
    return <div className="ud-durum" style={{ background: "#e8f5e9", color: "#1b5e20" }}>✅ <b>İndirim devam ediyor</b>{kontrol}</div>;
  }
  if (u.indirimDurumu === "SATISTA_DEGIL") {
    return <div className="ud-durum" style={{ background: "#eeeeee", color: "#424242" }}>⛔ <b>Ürün şu an satışta değil</b>{kontrol}</div>;
  }
  return (
    <div className="ud-durum" style={{ background: "#fff3e0", color: "#8a4b00" }}>
      ⏱ <b>İndirim sona erdi</b>{(u.guncelFiyat && !fiyatGizle) ? <span> · şu an <b>{tl(Number(u.guncelFiyat))}</b></span> : null}{kontrol}
      {u.kayitTarihi && <div style={{ fontSize: 12, color: "#68727e", marginTop: 2 }}>Bu fiyat {tarihSaat(u.kayitTarihi)} tarihinde yakalanmıştı.</div>}
    </div>
  );
}

function Yildizlar({ puan }) {
  const tam = Math.round(puan);
  return <span className="ud-yildiz" aria-hidden="true">{"★".repeat(tam)}<span style={{ color: "#d6dade" }}>{"★".repeat(5 - tam)}</span></span>;
}

/** Kampanya / koşul satırları (kupon, sepet indirimi, üyelik fiyatı, kargo). Boşlar atlanır. */
function kosullar(u, s) {
  const l = [];
  const ekle = (simge, metin) => {
    const m = (metin || "").toString().replace(/^[\s\-–—]+|[\s\-–—]+$/g, "").trim();
    if (m && !l.some((x) => x.metin === m)) l.push({ simge, metin: m });
  };
  if (u.toplanabilirKuponIndirimTutari && !/kupon/i.test(u.exstraKampanya || "")) ekle("🏷️", tl(Number(u.toplanabilirKuponIndirimTutari)) + " kupon toplanabilir");
  ekle("🎁", u.exstraKampanya);
  ekle("🛒", u.promotionName);
  if (s.uyelik[u.fiyatKaynagi]) ekle("💎", s.uyelik[u.fiyatKaynagi]);
  if (u.kargoBedavaMi === true) ekle("🚚", "Ücretsiz kargo");
  ekle("🚚", u.kargoBilgisi);
  return l;
}

/** Oturumda son görülen taze detay verisi (site + oid): ikinci gelişte önce bu gösterilir, arka planda tazelenir. */
const sonDetay = new Map();

export default function UrunDetay({ site, serverData, location }) {
  let s = SITELER[site];
  const [request] = useAxios();
  const isMobile = useIsMobile();
  const { isAuth, severity } = useContext(AuthContext);
  const { setLoading } = useContext(LoadingContext);
  const { setBreadcrumbdata } = useContext(BreadcrumbsContext);

  const sunucuVerisi = serverData && serverData.veri;
  const sunucuOid = sunucuVerisi && sunucuVerisi.urun ? String(sunucuVerisi.urun.oid) : null;
  const [veri, setVeri] = useState(() => (sunucuOid && sonDetay.get(site + sunucuOid)) || sunucuVerisi || null);
  s = siteBilgisi(site, veri && veri.urun);
  const [bulunamadi, setBulunamadi] = useState(false);
  const [yakalanmaOnce, setYakalanmaOnce] = useState(null);
  const [benzerler, setBenzerler] = useState([]);

  const aramaParametreleri = location && location.search;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const oidParam = urlParams.get("oid");
    const ad = urlParams.get("name") || (sunucuVerisi && sunucuVerisi.urun && sunucuVerisi.urun.name);
    setBreadcrumbdata([{ path: "/", name: "Ana sayfa" }, { path: s.liste, name: s.ad }, { path: window.location.pathname + window.location.search, name: ad }]);
    const temizle = () => setBreadcrumbdata([]);

    if (!oidParam) {
      navigate(s.liste + "/");
      return temizle;
    }
    const anahtar = site + oidParam;
    const tekrarGelis = sonDetay.has(anahtar);
    // SSR ile açıldıysa ekranda veri var ama Netlify CDN'inden gelmiş olabilir (5 dk taze + 1 saate kadar eski, utils/
    // ssrOnbellek): durum bandı / fiyat eski kalmasın diye arkada sessizce tazelenir (eskiden SSR verisiyle hiç sormuyordu)
    const sunucudanGeldi = sunucuOid === oidParam && !tekrarGelis;
    if (sunucudanGeldi) {
      sonDetay.set(anahtar, sunucuVerisi);
      setVeri(sunucuVerisi);
    } else if (tekrarGelis) {
      setVeri(sonDetay.get(anahtar));
    }
    // ilk gelişte (site içi tıklama: page-data boş) veri gelene kadar sayfanın kendi iskeleti görünür; genel Spin artık
    // açılmıyor (her detay tıklamasında iskeletin üstünü karartıyordu)
    request({
      url: s.api + "api/urundetaygetir",
      method: "get",
      headers: sunucuBasliklari(),
      params: { oid: oidParam },
    }, (response) => {
      setLoading(false);
      sonDetay.set(anahtar, response);
      setVeri(response);
    }, (error) => {
      setLoading(false);
      if (error && error.response && error.response.status === 404) {
        setBulunamadi(true);
        return;
      }
      if (!sunucudanGeldi && !tekrarGelis) { // ekranda veri varken tazeleme hatası kullanıcıya gösterilmez
        showAlert(error + " ", RESPONSE_TYPE.ERROR, "Hata!");
      }
    });
    return temizle;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aramaParametreleri, sunucuVerisi]);

  const u = veri && veri.urun;

  // "İlginizi çekebilir": sayfalı uçtan aynı kategoriden 12 devam eden indirim (azsa en yenilerle tamamlanır). Sayfa
  // açıldıktan biraz sonra istenir (ana içerikle yarışmasın). Eskiden her detayda 150'lik listenin tamamı (~200 KB)
  // iniyordu (2026-11-01). Uç yoksa (backend eski) o listeye düşer.
  useEffect(() => {
    if (!u) return undefined;
    let iptal = false;
    const ayikla = (l) => (l || []).filter((x) => String(x.oid) !== String(u.oid) && x.indirimDurumu !== "SONA_ERDI" && x.indirimDurumu !== "SATISTA_DEGIL");
    const t = setTimeout(async () => {
      try {
        const sor = (ek) => axios.get(s.api + "api/indirimler?boyut=13&devam=true" + ek).then((r) => ayikla(r.data.icerik));
        let l = u.categoryName ? await sor("&kategori=" + encodeURIComponent(u.categoryName)) : [];
        if (l.length < 6) {
          const yeni = await sor("");
          l = [...l, ...yeni.filter((x) => !l.some((y) => y.oid === x.oid))];
        }
        if (!iptal) setBenzerler(l.slice(0, 12));
      } catch (e) {
        request({ url: s.api + "api/sonindirimlistfordetail", method: "get" }, (r) => {
          if (iptal || !Array.isArray(r)) return;
          const digerleri = ayikla(r);
          const ayni = digerleri.filter((x) => x.categoryName && x.categoryName === u.categoryName);
          setBenzerler([...ayni, ...digerleri.filter((x) => !ayni.includes(x))].slice(0, 12));
        }, () => { });
      }
    }, 800);
    return () => { iptal = true; clearTimeout(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [u && u.oid]);
  useEffect(() => {
    setYakalanmaOnce(u && u.kayitTarihi ? neKadarOnce(u.kayitTarihi) : null);
  }, [u]);

  if (bulunamadi) {
    return (
      <div className="ud-sayfa" style={{ textAlign: "center", paddingTop: 48 }}>
        <h2 style={{ fontSize: "1.3rem", color: "#364354" }}>Bu indirim artık yayında değil</h2>
        <p style={{ color: "#68727e" }}>Aradığın fırsat kaldırılmış ya da süresi dolmuş olabilir. Güncel fırsatlara göz at.</p>
        <button onClick={() => navigate(s.liste)} className="ud-git" style={{ background: s.renk, color: s.yaziRengi || "#fff", maxWidth: 320, margin: "12px auto 0" }}>
          Güncel {s.ad} fırsatları →
        </button>
      </div>
    );
  }

  const link = u ? (u.linkgelir || "https://" + u.url) : null;
  const git = () => {
    const hedef = `${PATH_REDIRECT}?to=${encodeURIComponent(link)}&redirect=${s.ad}`;
    if (isMobile) window.location.href = hedef; else window.open(hedef);
  };
  const bitti = u && (u.indirimDurumu === "SONA_ERDI" || u.indirimDurumu === "SATISTA_DEGIL");
  const yeni = u ? Number(u.yeniFiyat) : null;
  const eski = u ? Number(u.eskiFiyat) : null;
  const puan = u ? Number(u.averageRating) : 0;
  const gitYazisi = s.fiyatGizle ? `${ekli(s)} güncel fiyatı gör` : `${ekli(s)} gör`;
  const gitDugmesi = (ek) => (
    <button type="button" className="ud-git" onClick={git} style={{ background: s.renk, color: s.yaziRengi || "#fff", ...ek }}>
      {gitYazisi} <span aria-hidden="true">→</span>
    </button>
  );

  return (
    <div className="ud-sayfa">
      <GenericBreadcrumbs />
      <div className="ud-kart">
        {!u ? (
          <div className="ud-ust">
            <div className="ud-iskelet" style={{ aspectRatio: "1 / 1", maxHeight: 460 }} />
            <div>
              <div className="ud-iskelet" style={{ height: 28, width: "85%" }} />
              <div className="ud-iskelet" style={{ height: 120, marginTop: 16 }} />
              <div className="ud-iskelet" style={{ height: 52, marginTop: 16 }} />
            </div>
          </div>
        ) : (
          <div className="ud-ust">
            <div className={"ud-gorsel" + (bitti ? " ud-gorsel-bitti" : "")}>
              {u.imageUrl && <img src={u.imageUrl} alt={u.name} />}
              <span className="ud-gorsel-rozet" style={{ background: s.renk, color: s.yaziRengi || "#fff" }}>{s.ad}</span>
            </div>

            <div style={{ minWidth: 0 }}>
              <div className="ud-magaza-satir">
                <span className="ud-magaza-adi" style={{ color: s.renk }}>{s.ad}</span>
                {u.marka && <span className="ud-marka">{u.marka}</span>}
              </div>
              <div className="ud-etiketler">
                {/* Reklam Kurulu sosyal medya etkileyicileri kılavuzu (2021): ortaklık (affiliate) içeriği #Ortaklık gibi bir
                    etiketle açık ve görünür biçimde belirtilmeli. Kaldırma. */}
                {s.ortaklik !== false && <span className="ud-etiket ud-etiket-ortaklik" title="Bu sayfadaki mağaza bağlantıları ortaklık bağlantısıdır">#Ortaklık</span>}
                {Number(u.telegramaGonderimDurumu) === 1 && <span className="ud-etiket ud-etiket-editor">★ Editörün seçimi</span>}
                {u.categoryName && <span className="ud-etiket">{u.categoryName}</span>}
              </div>
              <h1 className="ud-baslik">{u.name}</h1>
              {puan > 0 && (
                <div className="ud-puan">
                  <Yildizlar puan={puan} /> <b>{puan.toFixed(1).replace(".", ",")}</b>
                  {u.totalCount ? <span>· {Number(u.totalCount).toLocaleString("tr-TR")} değerlendirme</span> : null}
                </div>
              )}

              <div className="ud-fiyat-kutu">
                {s.fiyatGizle ? (
                  <div className="ud-gizli-fiyat">
                    {s.ad}'da bu üründe <b>fiyat düşüşü yakaladık</b>. Güncel fiyat ve stok {s.ad}'da değişebildiği için
                    fiyatı {s.ad} sayfasında göstermiyoruz.
                  </div>
                ) : (
                  <>
                    <div className="ud-fiyat-satir">
                      <span className={"ud-fiyat" + (bitti ? " ud-fiyat-bitti" : "")}>{tl(yeni)}</span>
                      {u.indirimOraniYuzde && <span className="ud-indirim">%{u.indirimOraniYuzde}</span>}
                      {eski > yeni && <span className="ud-eski">{tl(eski)}</span>}
                    </div>
                    {eski > yeni && <div className="ud-kazanc">{tl(Math.round((eski - yeni) * 100) / 100)} daha ucuz</div>}
                  </>
                )}
                {yakalanmaOnce && <div className="ud-yakalanma">İndirim {yakalanmaOnce} yakalandı</div>}
                {kosullar(u, s).length > 0 && (
                  <ul className="ud-kosullar">
                    {kosullar(u, s).map((k, i) => (
                      <li key={i} className="ud-kosul"><span className="ud-kosul-simge" aria-hidden="true">{k.simge}</span><span>{k.metin}</span></li>
                    ))}
                  </ul>
                )}
              </div>

              <DurumBandi u={u} fiyatGizle={s.fiyatGizle} />
              {/* telefonda gizli: altta fiyatlı sabit çubuk hep duruyor (aynı düğme iki kez görünmesin) */}
              <div className="ud-ust-git">{gitDugmesi()}</div>
              <TakipDugmeleri site={site} urunId={u.id != null ? String(u.id) : null} fiyat={yeni} />
              {s.ortaklik !== false && <div className="ud-ortaklik-not">#Ortaklık · {s.ad} bağlantısı ortaklık bağlantısıdır</div>}
              <div className="ud-bilgiler">
                <div className="ud-bilgi" style={{ borderLeftColor: s.renk }}><span>Pazaryeri</span><b>{s.ad}</b></div>
                {u.magazaAdi && <div className="ud-bilgi"><span>Satıcı</span><b>{u.magazaAdi}</b></div>}
                <div className="ud-bilgi"><span>Durum</span><b style={{ color: durumRengi(u) }}>{durumYazisi(u)}</b></div>
                {u.totalCount && Number(u.totalCount) > 0 && <div className="ud-bilgi"><span>Değerlendirme</span><b>{Number(u.totalCount).toLocaleString("tr-TR")}</b></div>}
                {u.categoryName && <div className="ud-bilgi"><span>Kategori</span><b>{u.categoryName}</b></div>}
                {u.takipBaslangicTarihi && <div className="ud-bilgi"><span>Takipte</span><b>{new Date(u.takipBaslangicTarihi).toLocaleDateString("tr-TR", { month: "long", year: "numeric" })}'den beri</b></div>}
              </div>
              {/* pazaryeri / satıcı bilgilerinden sonra (kullanıcı kararı 2026-11-05) */}
              <DigerMagazalar site={site} u={u} fiyat={s.fiyatGizle ? null : yeni} />
              {(isAuth === 1 && severity === 1) && (
                <a className="ud-admin" target="_blank" rel="noopener noreferrer" href={PATH_ADMIN + s.panel + "/?oid=" + u.oid}>Admin kontrol →</a>
              )}
              <TakipEt vurgulu={bitti} />
            </div>
          </div>
        )}
      </div>

      {u && (
        <div className="ud-kart">
          <FiyatGecmisi gecmis={veri.urunHistoryList} urun={u} renk={s.renk} fiyatGizle={!!s.fiyatGizle} urunAdi={u.name} magaza={s.ad} />
        </div>
      )}

      {benzerler.length > 0 && (
        <div className="ud-kart">
          <h2 className="ud-bolum-baslik">💡 İlginizi çekebilir</h2>
          <KaydirmaSeridi>
            {benzerler.map((x) => (
              <GenericCardV2 key={x.oid} etiketler={kartEtiketleri(x)} incelepath={s.detay} aciklama={x.name} img={x.imageUrl}
                indirim={"%" + x.indirimOraniYuzde} fiyat={x.yeniFiyat} eskifiyat={x.eskiFiyat} subheader={s.ad} magaza={x.magaza} fiyatGizle={!!s.fiyatGizle}
                indirimDurumu={x.indirimDurumu} guncelFiyat={x.guncelFiyat} oid={x.oid} averageRating={x.averageRating}
                totalCount={x.totalCount} telegramaGonderimDurumu={x.telegramaGonderimDurumu} kayitTarihi={x.kayitTarihi} />
            ))}
          </KaydirmaSeridi>
        </div>
      )}

      <div className="ud-kisayollar">
        <button type="button" className="ud-kisayol" onClick={() => navigate(s.liste)}>
          <span className="ud-kisayol-simge" style={{ background: s.renk + "1a", color: s.renk }}>🔥</span>
          <span><b>Tüm {s.ad} indirimleri</b><small>En yeni gerçek indirimler, filtreleriyle</small></span>
        </button>
        <a className="ud-kisayol" href={TELEGRAM_KANAL} target="_blank" rel="noopener noreferrer">
          <span className="ud-kisayol-simge ud-ks-telegram"><TelegramIcon /></span>
          <span><b>Telegram kanalı</b><small>Fırsatlar anında bildirim olarak gelsin</small></span>
        </a>
        <a className="ud-kisayol" href={WHATSAPP_KANAL} target="_blank" rel="noopener noreferrer">
          <span className="ud-kisayol-simge ud-ks-whatsapp"><WhatsAppIcon /></span>
          <span><b>WhatsApp kanalı</b><small>Günün en iyi indirimleri cebinde</small></span>
        </a>
        <a className="ud-kisayol" href={INSTAGRAM_HESABI} target="_blank" rel="noopener noreferrer">
          <span className="ud-kisayol-simge ud-ks-instagram"><InstagramIcon /></span>
          <span><b>Instagram</b><small>Fırsatları akışında gör</small></span>
        </a>
      </div>

      {u && (
        <div className="ud-kart">
          <h2 className="ud-bolum-baslik">🏷️ Etiketler</h2>
          <div className="ud-etiket-bulut">
            {s.ortaklik !== false && <span className="ud-etiket ud-etiket-ortaklik">#Ortaklık</span>}
            <span className="ud-etiket" style={{ background: s.renk + "1a", color: s.renk }}>{s.ad}</span>
            {u.categoryName && <span className="ud-etiket">{u.categoryName}</span>}
            {u.marka && <span className="ud-etiket">{u.marka}</span>}
            {u.magazaAdi && u.magazaAdi !== u.marka && <span className="ud-etiket">{u.magazaAdi}</span>}
            {(u.icOrtakId || u.id) && <span className="ud-etiket ud-etiket-kod">{u.icOrtakId || String(u.id).split("-")[0]}</span>}
          </div>
        </div>
      )}

      <div className="ud-reklam"><AdCardDetail /></div>

      <p className="ud-not">
        Fiyatlar ve stok durumu {s.ad} tarafından değiştirilebilir; satın almadan önce {s.ad} sayfasındaki güncel fiyatı
        kontrol et.{s.ortaklik !== false && <> <b>#Ortaklık</b> · İndirim Uzmanı bu sayfadaki bağlantılardan ortaklık komisyonu
        kazanabilir; bu, ödediğin fiyatı değiştirmez.{s.ortaklikBeyani ? " " + s.ortaklikBeyani : ""}</>}
      </p>

      {u && (
        <div className="ud-alt-cubuk">
          {!s.fiyatGizle && (
            <div className="ud-alt-fiyat">
              <b>{tl(yeni)}</b>
              {eski > yeni && <s>{tl(eski)}</s>}
            </div>
          )}
          {gitDugmesi()}
        </div>
      )}
    </div>
  );
}
